import React, { PropsWithChildren } from 'react';

import Tooltip from 'component/Layout/Tooltip';

import { ReactComponent as IconInfo } from 'media/svg/infoCircle.svg';

import styles from '../Segment.module.scss';

export interface GroupHeadlineProps {
    text: string;
    tooltip?: React.ReactNode;
}

const GroupHeadline: React.FC<PropsWithChildren<GroupHeadlineProps>> = ({
    text,
    tooltip,
    children,
}) => (
    <title className={styles.GroupHeadline}>
        <h3>
            <span dangerouslySetInnerHTML={{ __html: text }} />
            {tooltip && (
                <Tooltip
                    overlayClassName={styles.Tooltip}
                    content={
                        <span dangerouslySetInnerHTML={{ __html: tooltip }} />
                    }
                    align={{
                        offset: [16, 0],
                    }}
                >
                    <span className={styles.IconWrapper}>
                        &nbsp;
                        <IconInfo className={styles.Icon} />
                    </span>
                </Tooltip>
            )}
        </h3>
        {children}
    </title>
);

export default GroupHeadline;
